import moment from 'moment';
import get from 'lodash/get';
import { numberToDecimal } from '../../utils/currency';
import { API_DATE_FORMAT } from '../../constants';

export const columnsDefaults = {
  actions: {
    filterable: false,
    menuDisplay: false,
    lockPosition: true
  },
  number: {
    filter: 'agNumberColumnFilter',
    type: 'number',
    cellClass: 'text-right',
    headerClass: 'agGridColumnHeader--text-align-right'
  },
  amount: {
    filter: 'agNumberColumnFilter',
    type: 'number',
    cellClass: 'text-right',
    headerClass: 'agGridColumnHeader--text-align-right',
    valueFormatter: numberToDecimal,
    filterValueGetter: ({ data }) => Number(data.amount),
    valueGetter: ({ data }) => Number(data.amount)
  },
  credit: {
    filter: 'agNumberColumnFilter',
    type: 'number',
    cellClass: 'text-right',
    headerClass: 'agGridColumnHeader--text-align-right',
    valueFormatter: numberToDecimal,
    filterValueGetter: ({ data }) => Number(data.credit),
    valueGetter: ({ data }) => Number(data.credit)
  },
  debit: {
    filter: 'agNumberColumnFilter',
    type: 'number',
    cellClass: 'text-right',
    headerClass: 'agGridColumnHeader--text-align-right',
    valueFormatter: numberToDecimal,
    filterValueGetter: ({ data }) => Number(data.debit),
    valueGetter: ({ data }) => Number(data.debit)
  },
  numItems: {
    filter: 'agNumberColumnFilter',
    type: 'number',
    cellClass: 'text-right',
    headerClass: 'agGridColumnHeader--text-align-right',
    filterValueGetter: ({ data }) => Number(data.numItems),
    valueFormatter: ({ data }) => Number(data.numItems),
    valueGetter: ({ data }) => Number(data.numItems)
  },
  select: {
    filterable: false,
    menuDisplay: false,
    lockPosition: true
  }
};

function isSelectOrActions(column, locale) {
  if (column.checkboxSelection === true) {
    return columnsDefaults.select;
  }
  if (column.headerName === locale['common.actions']) {
    return columnsDefaults.select;
  }
  return false;
}

function isDate(column) {
  if (column.type !== 'date') {
    return false;
  }
  return {
    filter: 'agDateColumnFilter',
    filterParams: {
      inRangeInclusive: true
    },
    /*
     * Assumes the date is in a standard format.
     * May need to be overridden.
     */
    filterValueGetter: ({ data }) => moment(data[column.field], API_DATE_FORMAT).toDate()
  };
}

function isNumber(column) {
  if (column.type !== 'number') return false;
  return columnsDefaults.number;
}

function text(column) {
  // value - for export to csv
  // toLowerCase - for ignoring case sensitive while sort
  return {
    valueFormatter: ({ data, value }) => get(data, column.field, value),
    valueGetter: ({ data }) => (get(data, column.field) || '').toString().toLowerCase()
  };
}

export function mapColumnProps(locale) {
  return (column) => {
    const defaults =
      columnsDefaults[column.field] ||
      isSelectOrActions(column, locale) ||
      isDate(column) ||
      isNumber(column) ||
      text(column);
    return {
      ...defaults,
      ...column
    };
  };
}
